import { http } from '@pendo/http';

export function fetchTeams () {
    return http.get('/api/s/_SID_/teams').then((res) => res.data);
}

export function createTeam (team) {
    return http.post('/api/s/_SID_/teams', team).then((res) => res.data);
}

export function deleteTeam (id) {
    return http.delete(`/api/s/_SID_/teams/${id}`).then((res) => res.data);
}

export function updateTeamDetails (team) {
    return http.put(`/api/s/_SID_/teams/${team.id}`, team).then((res) => res.data);
}

export function fetchUserTeams (userId) {
    return http.get(`/api/s/_SID_/user/${userId}/teams`).then((res) => res.data);
}

export function fetchTeamMembers (id) {
    return http.get(`/api/s/_SID_/teams/${id}/members`).then((res) => res.data);
}

export function updateTeamMembers (members, id) {
    return http.patch(`/api/s/_SID_/teams/${id}/members`, members).then((res) => res.data);
}
